import React, { useEffect, useState } from "react";
import { Table, Button, IconPlus, Search, IconDownload} from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Col, Row } from "react-bootstrap";
import UploadModalDate from './UploadModalDate';
import XLSX from "xlsx";
import $ from 'jquery';

const GlobalAccountRender = ( props ) => {
    //Variables
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [dataGlobal, setDataGlobal] = useState([]);
    const [dataListGT, setDataListGT] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [dateSelected, setDateSelected] = useState();
    const [datacounter, setdatacounter]=useState(1);

    //Metodos
    const fetchData = async () => {
        setDateSelected('');
        setDataGlobal([]);
        setDataListGT([]);

        connectApi.get(
            "api/Channels/AllTables",
            { params: { viewRequired: 'global_account' } },
            dataResponseLoad
        ).catch((error) => {
            setLoadingData(false);
            Swal.fire(
                "Error " + error.response,
                error.response,
                "error"
            );
        });
        setLoadingData(true);
    };
    const dataResponseLoad = (status, data) => {
        setDateSelected( moment(data['date']).format("MM-DD-YYYY") );
        data['globalTier'].forEach(x => {
            x.startDate = moment(x.startDate).format("MMM/DD/YYYY");
            x.endDate = moment(x.endDate).format("MMM/DD/YYYY"); 
        });
        setDataGlobal(data['globalTier'] === undefined ? [] : data['globalTier']);
        setDataListGT(data['dataListGT'] === undefined ? [] : data['dataListGT']);
        setLoadingData(false)
    };
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        fetchData();
    }, [datacounter]);
    
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if (  orderBy === "idPress" ){
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } if( orderBy === "channel" || orderBy === "name" 
            || orderBy === "createdBy" || orderBy === "classification" 
            || orderBy === "description" || orderBy==="namecustomer" || orderBy==="nameEndUser" ){
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        } else if( orderBy === "startDate" || orderBy === "endDate"
                || orderBy === "date" || orderBy === "monthYear" ){
   
                    
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        }else{
            if (parseFloat(bSort) < parseFloat(aSort)) 
                return -1;
            if (parseFloat(bSort) > parseFloat(aSort))
                return 1;
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                    const aUpper = a[value] && a[value].toString().toUpperCase();
                    const filterUpper = filter && filter.toString().toUpperCase();
                    return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }
    
    const [showModal, setShowModal] = useState(false);
    const [orderBy, setOrderBy] = useState("startDate");
    const [orderType, setOrderType] = useState("descending");
    const [nameFilter, setNameFilter] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [channelFilter, setChannelFilter] = useState("");
    const [itemSelect, setItemSelect] = useState([]);
    const [modifyValues, setModifyValues] = useState(false);
    const pageSize = 25;
    const [order, setOrder] = useState([
        'channel',
        'name',
        'idPressList',
        'startDate',
        'endDate',
        'serie3MCClick',
        'serie31cClick',
        'serie32cClick',
        'serie3EPMClick', 
        'series4BlackClick',
        'series4OtherClick', 
        'series4OneShotClick', 
        'series4WhiteClick'
    ]);
    const handlePageChange = (page) => setCurrentPage(page);
    
    const filteredData = filterSort(
        dataGlobal, {
            name: nameFilter,
            channel: channelFilter,
        },
        orderBy,
        orderType
    );
    
    let pagedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    function setModalParameters(e){
        var channel = $(e.target).closest('tr').children().eq(0).text();
        var endUserName = $(e.target).closest('tr').children().eq(1).text();
        var idPress = $(e.target).closest('tr').children().eq(2).text()==''?undefined:$(e.target).closest('tr').children().eq(2).text();
        var startDate = $(e.target).closest('tr').children().eq(3).text();
        var endDate = $(e.target).closest('tr').children().eq(4).text();
        if( channel !== t("channel") & endUserName !== t("endUser") & startDate !== '' & idPress !== t("pressid")
        & new Date(dateSelected) >= new Date(startDate) & new Date(dateSelected) <= new Date(endDate) ){
            let vaItem = dataGlobal.find(gt => gt.channel === channel & gt.name === endUserName & gt.startDate === startDate & gt.endDate === endDate & gt.idPressList[0] === idPress);
            setItemSelect(vaItem);
            setModifyValues(true);
            setShowModal(true);
        }
    };

    return (<div>
        <Row>
            <Col 
                style={{
                    position: "absolute",
                    marginTop: "5px",
                }}
            >
                <Button
                    leadingIcon={<IconPlus />}
                    onClick={() => {setShowModal(true); setModifyValues(false);}}
                    loading={loadingData}
                >{t("addNew")} Global Tier</Button>
            </Col>
        </Row>
        <div>
            <Table
                onClick={setModalParameters}
                columns = {[
                    {
                        id: 'channel',
                        label: t("channel"),
                        filter: (
                            <Search
                                id="channel-filter"
                                value={channelFilter}
                                onChange={(val) => {
                                    setChannelFilter(val);
                                    setCurrentPage(1);
                                }}
                            />
                        )
                    },
                    {
                        id: 'name',
                        label: t("endUser"),
                        filter: (
                            <Search
                                id="name-filter"
                                value={nameFilter}
                                onChange={(val) => {
                                    setNameFilter(val);
                                    setCurrentPage(1);
                                }}
                            />
                        )
                    },
                    {
                        id: 'idPressList',
                        label: t("pressid")
                    },
                    {
                        id: 'startDate',
                        label: t("specialcondition.startdate")
                    },
                    {
                        id: 'endDate',
                        label: t("specialcondition.enddate")
                    },
                    {
                        id: 'serie3MCClick',
                        label: t("series3") + " MCClick"
                    },
                    {
                        id: 'serie31cClick',
                        label: t("series3") + " 1cClick"
                    },
                    {
                        id: 'serie32cClick',
                        label: t("series3") + " 2cClick"
                    },
                    {
                        id: 'serie3EPMClick',
                        label: t("series3") + " EPMClick"
                    },
                    {
                        id: 'series4BlackClick',
                        label: t("series4") + " Series4BlackClick"
                    },
                    {
                        id: 'series4OtherClick',
                        label: t("series4") + " Series4OtherClick"
                    },
                    {
                        id: 'series4OneShotClick',
                        label: t("series4") + " Series4OneShotClick"
                    },
                    {
                        id: 'series4WhiteClick',
                        label: t("series4") + " Series4WhiteClick"
                    },
                ]}
                showFilters
                columnReorder
                data={pagedData}
                loading={loadingData}
                onSort={handleSort}
                onColumnReorder={(reOrder) => setOrder(reOrder)}
                preferences={{
                    defaultOrder: order,
                    sortBy: {
                        id: orderBy,
                        type: orderType,
                    },
                    order: order
                }}
                pagination={{
                    currentPage,
                    onPageChange: handlePageChange,
                    pageSize,
                    totalItems: filteredData.length,
                }}
            />
            <div style={{ textAlign: "left" }}>
                <Button
                    onClick={()=>{
                        setTimeout(() => {
                        const dataXlsx = filteredData.map((item) => { return item; });
                        const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                        const wb = XLSX.utils.book_new();
                        const date = moment(new Date()).format('YYYYMMDDHHmm');
                        const filename = 'GlobalTier-' + date + '.xlsx';
                        const ws_name = "GlobalTier";
                        XLSX.utils.book_append_sheet(wb, ws, ws_name);
                        XLSX.writeFile(wb, filename);
                        }, 750);
                    }}
                    disabled={filteredData.length === 0}
                    leadingIcon={<IconDownload />}
                    title={t('download data')}
                    >
                    {t('download')}
                </Button>
            </div>
        </div>
        <UploadModalDate
            key={showModal ? true : false}
            showModal={showModal}
            setShowModal={setShowModal}
            tabView="global_tier"
            dataGlobal={dataGlobal}
            dataList={dataListGT}
            dateInit={dateSelected}
            valueModify={modifyValues}
            setValueModify={setModifyValues}
            itemModify={itemSelect}
            fetchData={useEffect}
            datacounter={datacounter}
            setdatacounter={setdatacounter}
        />
    </div>);
}

export default GlobalAccountRender;